import { render, staticRenderFns } from "./Game_Version.vue?vue&type=template&id=839fac14&scoped=true"
import script from "./Game_Version.vue?vue&type=script&lang=js"
export * from "./Game_Version.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "839fac14",
  null
  
)

export default component.exports